// extracted by mini-css-extract-plugin
module.exports = {"title":"_bb9450e5","chips":"_259125a3","informing":"_2bed1ddb"};